import React from 'react';

import { IIconProps } from './constants';

export const MultiPhotoIcon = ({
  height = 24,
  width = 24,
  ariaLabel = 'Multiple photos',
}: IIconProps) => {
  return (
    <svg
      aria-label={ariaLabel}
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_418_33341)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 30C29.1046 30 30 29.1046 30 28L30 12C30 10.8954 29.1046 10 28 10H12C10.8954 10 10 10.8954 10 12V28C10 29.1046 10.8954 30 12 30L28 30ZM34 32C34 33.1046 33.1046 34 32 34L16 34C14.8954 34 14 33.1046 14 32L30 32C31.1046 32 32 31.1046 32 30L32 14C33.1046 14 34 14.8954 34 16L34 32Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_418_33341"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_33341" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_418_33341"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
